module.exports = __webpack_public_path__ + "static/img/493c65d42fe83ec3daaf058d79fc1a95.493c65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/item/493c65d42fe83ec3daaf058d79fc1a95.jpg
// module id = UYUW
// module chunks = 0